var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGovernance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.89323 4.71191L7.16406 5.53226L8.13628 6.62272H1.81684L2.78906 5.53226L2.0599 4.71191L0.601562 6.3476V8.62356C0.601562 9.1738 1.03906 9.62399 1.57378 9.62399H8.37934C8.91406 9.62399 9.35156 9.1738 9.35156 8.62356V6.35261L7.89323 4.71191Z",
    fill: "#DBE1E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.29123 5.96002C4.6704 6.35518 5.28776 6.36019 5.67179 5.96502L8.09262 3.47397C8.47179 3.0838 8.47179 2.44853 8.09262 2.05837L6.37179 0.292624C5.99262 -0.0975411 5.37526 -0.0975411 4.99609 0.292624L2.58984 2.76867C2.40812 2.95545 2.3056 3.20864 2.30469 3.47293C2.30378 3.73723 2.40455 3.99116 2.58498 4.17926L4.29123 5.96002ZM5.70604 0.49728L7.89354 2.74823L4.97687 5.7495L2.78937 3.47397L5.70604 0.49728Z",
    fill: "#DBE1E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGovernance);
export default __webpack_public_path__ + "static/media/ic_governance.aabfca7b27553348dfefae9f15ec2072.svg";
export { ForwardRef as ReactComponent };